import PropTypes from 'prop-types'

import React, { useRef, useState } from 'react'

import { Modal } from 'antd'
import Draggable from 'react-draggable'

/**
 *  draggable modal for with confirmation
 * @param {Object} param
 * @returns
 */

const ConfirmModal = ({
  open,
  handleCancel,
  handleOk,
  OkText,
  defaultType,
  OkBgColor,
  title,
}) => {
  const [bounds, setBounds] = useState({
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
  })
  const draggleRef = useRef(null)

  const onStart = (_event, uiData) => {
    const { clientWidth, clientHeight } = window.document.documentElement
    const targetRect = draggleRef.current?.getBoundingClientRect()
    if (!targetRect) {
      return
    }
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    })
  }

  return (
    <>
      <Modal
        title={
          <div
            style={{
              width: '100%',
              cursor: 'move',
            }}
          >
            {title}
          </div>
        }
        open={open}
        okButtonProps={{ style: { backgroundColor: OkBgColor, color: '#fff' } }}
        cancelButtonProps={{
          type: 'danger',
          style: { backgroundColor: '#8c8c8c', color: '#fff' },
        }}
        onOk={() => handleOk()}
        okType={defaultType}
        onCancel={handleCancel}
        okText={OkText}
        modalRender={(modal) => (
          <Draggable
            // disabled={disabled}
            bounds={bounds}
            nodeRef={draggleRef}
            onStart={(event, uiData) => onStart(event, uiData)}
          >
            <div ref={draggleRef}>{modal}</div>
          </Draggable>
        )}
      ></Modal>
    </>
  )
}

ConfirmModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleOk: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  OkText: PropTypes.string,
  defaultType: PropTypes.string,
  OkBgColor: PropTypes.string,
  title: PropTypes.string,
}

ConfirmModal.defaultProps = {
  OkText: 'Confirm',
  defaultType: 'danger',
  OkBgColor: '#f5222d',
  title: 'Are you sure?',
}

export default ConfirmModal
